import React, {ReactNode} from 'react';
import classnames from 'classnames';

const CSS = require('./PageContentBlock.scss');

type PageContentBlockProps = {
    children: ReactNode;
    fullWidth?: boolean;
    alternateBackground?: boolean;
    textColor?: string;
    backgroundColor?: string;
}

const PageContentBlock = ({alternateBackground, backgroundColor, textColor, fullWidth, children}: PageContentBlockProps) => {
    const classes = classnames(CSS.PageContentBlock, {
        [CSS.AlternateBackground]: alternateBackground
    });
    return (
        <div className={classes} style={{
            backgroundColor: backgroundColor,
            color: textColor
        }}>
            <div className={classnames(CSS.Children)}>
                {children}
            </div>
        </div>
    )
};

export default PageContentBlock;
